import { MuiAccordion } from './MuiAccordion';
import { MuiAlert } from './MuiAlert';
import { MuiAppBar } from './MuiAppBar';
import { MuiAutocomplete } from './MuiAutocomplete';
import { MuiAvatar } from './MuiAvatar';
import { MuiBadge } from './MuiBadge';
import { MuiBreadcrumbs } from './MuiBreadcrumbs';
import { MuiButton } from './MuiButton';
import { MuiButtonGroup } from './MuiButtonGroup';
import { MuiCheckbox } from './MuiCheckbox';
import { MuiChip } from './MuiChip';
import { MuiCircularProgress } from './MuiCircularProgress';
import { MuiCssBaseline } from './MuiCssBaseline';
import { MuiDialogTitle } from './MuiDialogTitle';
import { MuiDrawer } from './MuiDrawer';
import { MuiFormControl } from './MuiFormControl';
import { MuiLinearProgress } from './MuiLinearProgress';
import { MuiList } from './MuiList';
import { MuiListItem } from './MuiListItem';
import { MuiListItemButton } from './MuiListItemButton';
import { MuiListItemSecondaryAction } from './MuiListItemSecondaryAction';
import { MuiMenuItem } from './MuiMenuItem';
import { MuiOutlinedInput } from './MuiOutlinedInput';
import { MuiPaper } from './MuiPaper';
import { MuiRadio } from './MuiRadio';
import { MuiSlider } from './MuiSlider';
import { MuiTab } from './MuiTab';
import { MuiToggleButton } from './MuiToggleButton';
import { MuiToggleButtonGroup } from './MuiToggleButtonGroup';
import { MuiTooltip } from './MuiTooltip';
import { MuiTreeView } from './MuiTreeView';
export var components = {
    MuiAccordion: MuiAccordion,
    MuiAlert: MuiAlert,
    MuiAvatar: MuiAvatar,
    MuiBadge: MuiBadge,
    MuiBreadcrumbs: MuiBreadcrumbs,
    MuiButton: MuiButton,
    MuiButtonGroup: MuiButtonGroup,
    MuiCheckbox: MuiCheckbox,
    MuiChip: MuiChip,
    MuiCircularProgress: MuiCircularProgress,
    MuiDialogTitle: MuiDialogTitle,
    MuiLinearProgress: MuiLinearProgress,
    MuiList: MuiList,
    MuiListItem: MuiListItem,
    MuiListItemButton: MuiListItemButton,
    MuiListItemSecondaryAction: MuiListItemSecondaryAction,
    MuiRadio: MuiRadio,
    MuiSlider: MuiSlider,
    MuiTooltip: MuiTooltip,
    MuiAppBar: MuiAppBar,
    MuiAutocomplete: MuiAutocomplete,
    MuiCssBaseline: MuiCssBaseline,
    MuiDrawer: MuiDrawer,
    MuiFormControl: MuiFormControl,
    MuiMenuItem: MuiMenuItem,
    MuiPaper: MuiPaper,
    MuiOutlinedInput: MuiOutlinedInput,
    MuiToggleButton: MuiToggleButton,
    MuiToggleButtonGroup: MuiToggleButtonGroup,
    MuiTab: MuiTab,
    MuiTreeView: MuiTreeView,
};
